const deathPrayersSelectors = {
  getDeathPrayers: state => state.deathPrayers,
};

export default deathPrayersSelectors;
